import React from 'react'
import {useShopperBasketsMutationHelper} from '@salesforce/commerce-sdk-react'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useIntl} from 'react-intl'
import {useCustomToast} from '../../../contexts/custom-toast-context'
import {useAddToCartConfirmation} from '../../../contexts/add-to-cart-confirmation-context'
import {sendItemCartEvent} from '../../../utils/gtm-utils'
import {sendBrazeCartEvent} from '../../../utils/braze-utils'
import {trackAddToBagEvent} from '../../../utils/optimizely-web-exp-utils'

const useProductTileCart = ({
    product,
    variant,
    productId,
    id,
    isWishlistPage,
    removeItemFromWishlist,
    ref,
    setIsQuickViewOpen,
    isDesktop,
    onAddToCartModalOpen,
    onAddToCartModalClose
}) => {
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const {showCustomToast} = useCustomToast()
    const navigate = useNavigation()
    const intl = useIntl()
    const {openConfirmation} = useAddToCartConfirmation()

    const addProductToCart = async (productSelectionValues) => {
        try {
            const productItems = productSelectionValues.map(({variant}) => ({
                productId: variant.productId,
                price: variant.price,
                quantity: 1
            }))

            const basket = await addItemToNewOrExistingBasket(productItems)

            // GTM Modification
            sendItemCartEvent(productItems[0], false)

            // Braze Modification - Send Braze Cart Event
            sendBrazeCartEvent(basket, productSelectionValues[0]?.currentProduct, 'add')

            trackAddToBagEvent({
                sku: productItems[0].productId,
                value: productItems[0].price,
                source: 'product-tile'
            })

            return productSelectionValues
        } catch (error) {
            console.error('The error occured while adding a product to the basket: ', error)
        }
    }

    // Handle cart item addition with validation
    const handleCartItem = async () => {
        try {
            const itemsAdded = await addProductToCart([{product, variant}])

            if (itemsAdded) {
                // Remove from wishlist if on wishlist page
                if (isWishlistPage) {
                    const productObj = {productId: productId || id, ...product}
                    await removeItemFromWishlist(productObj, ref?.current, 'add-to-cart-context')
                }

                setIsQuickViewOpen(false)
                openConfirmation({product, variant, quantity: 1})
            }
        } catch (e) {
            console.log(e)
        }
    }

    return {handleCartItem}
}

export default useProductTileCart
